import ApiService from "@/api.service";
import API from "@/API";


export const GET_LIST_NEWS = "listNews";
export const SET_LIST_NEWS = "setNews";
export const GET_DETAIL_NEWS = "getDetailNews";
export const SET_DETAIL_NEWS = "setDetailNews";
export const DELETE_NEWS = "deleteNews";
export const UPLOAD_NEWS_IMAGE = "uploadImage";
export const SAVE_NEWS = "saveNews";
export const UPDATE_NEWS = "updateNews";
export const GET_LIST_CATEGORIES = "getListCategories";
export const SET_LIST_CATEGORIES = "setListCategories";

export const GET_LIST_NEWS_SEARCH = "listNewsSearch";
export const SET_LIST_NEWS_SEARCH = "setNewsSearch";
const state = {
    news: [],
    newsDetail: [],
    category: [],
    newSearches : [],
};

const getters = {
    news(state) {
        return state.news;
    },
    newsDetail(state) {
        return state.newsDetail;
    },
    category(state) {
        return state.category;
    },
    newSearches(state) {
        return state.newSearches;
    }

};

const actions = {
    [GET_LIST_NEWS](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_NEWS}`).then(({ data }) => {

                if (data.status) {
                    context.commit(SET_LIST_NEWS, data);
                    context.commit(SET_LIST_NEWS_SEARCH, data.data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_NEWS_SEARCH](context,payload) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_NEWS_SEARCH}`, payload).then(({ data }) => {

                if (data.status) {
                    context.commit(SET_LIST_NEWS_SEARCH, data.data.posts);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_CATEGORIES](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_CATEGORIES}`).then(({ data }) => {

                if (data.status) {
                    context.commit(SET_LIST_CATEGORIES, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_NEWS](context, id) {

        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_NEWS}/${id}`).then(({ data }) => {
                if (data.status) {

                    context.commit(SET_DETAIL_NEWS, data);
                }
                resolve(data);
            });
        });
    },
    [DELETE_NEWS](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_NEWS}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_NEWS_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_NEWS_IMAGE}`, payload)
                .then((data) => {

                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    [SAVE_NEWS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_NEWS}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_NEWS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_NEWS}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_NEWS](state, data) {
        state.news = data.data;
    },

    [SET_DETAIL_NEWS](state, data) {
        state.newsDetail = data.data;
    },
    [SET_LIST_CATEGORIES](state, data) {
        state.category = data.data;
    },
    [SET_LIST_NEWS_SEARCH](state, data) {
        state.newSearches = data;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};